import { Box, Stack, Typography } from '@mui/material'
import type { JSX } from 'react'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { getDeviceDetails } from '@/api/Device'
import Card from '@/components/Card/Card'
import CardHeader from '@/components/Card/CardHeader'
import type { Device } from '@/pages/Device/Device'

import FotaHistory from './History'

export default function DeviceFota(): JSX.Element {
  const { uid } = useParams<{ uid: string }>()
  const [t] = useTranslation('app')
  const [device, setDevice] = useState<Device>()

  const fetchData = useCallback(async () => {
    if (!uid) {
      return <></>
    }
    try {
      const data = await getDeviceDetails(uid)
      setDevice(data)
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  }, [uid])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  if (!device) {
    return <></>
  }

  return (
    <Box sx={{ padding: '24px' }}>
      <Card>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <CardHeader>
            <Typography variant="h4">
              {t('device.fotaDeviceInfo.tableTitle')}
            </Typography>
          </CardHeader>
        </Stack>
        <FotaHistory />
      </Card>
    </Box>
  )
}
